module.exports = __webpack_public_path__ + "img/[OK].bfc4a6da.svg";